import { render, staticRenderFns } from "./Rerender.vue?vue&type=template&id=9edbcda4"
import script from "./Rerender.vue?vue&type=script&lang=js"
export * from "./Rerender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports